import UseFacebook from './UseFacebook';

export default UseFacebook;
